var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebugIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,14.9c-0.3,0-0.5,0.2-0.5,0.5v1.1C8,16.8,8.2,17,8.5,17S9,16.8,9,16.5v-1.1C9,15.1,8.8,14.9,8.5,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,9.4V0.5C9,0.2,8.8,0,8.5,0S8,0.2,8,0.5v8.9c-1,0.2-1.7,1.1-1.7,2.2c0,1.2,1,2.3,2.3,2.3s2.3-1,2.3-2.3 C10.8,10.5,10,9.6,9,9.4z M8.5,12.8c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S9.2,12.8,8.5,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,8.2c-0.3,0-0.5,0.2-0.5,0.5v7.8c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V8.7C15.3,8.4,15,8.2,14.7,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,2.7V0.5C15.3,0.2,15,0,14.7,0s-0.5,0.2-0.5,0.5v2.2c-1,0.2-1.7,1.1-1.7,2.2c0,1.2,1,2.3,2.3,2.3 c1.2,0,2.3-1,2.3-2.3C17,3.8,16.3,2.9,15.3,2.7z M14.7,6.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2S16,4.2,16,4.9 C16,5.6,15.4,6.1,14.7,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,11.4c-0.3,0-0.5,0.2-0.5,0.5v4.6C1.7,16.8,2,17,2.3,17c0.3,0,0.5-0.2,0.5-0.5v-4.6 C2.8,11.6,2.5,11.4,2.3,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,5.9V0.5C2.8,0.2,2.5,0,2.3,0C2,0,1.7,0.2,1.7,0.5v5.4C0.7,6.1,0,7,0,8.1c0,1.2,1,2.3,2.3,2.3 c1.2,0,2.3-1,2.3-2.3C4.5,7,3.8,6.1,2.8,5.9z M2.3,9.3C1.6,9.3,1,8.8,1,8.1c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2 C3.5,8.8,2.9,9.3,2.3,9.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebugIcon);
export default __webpack_public_path__ + "static/media/debug-icon.b2198de2e9c2ef87d07bbd9471def237.svg";
export { ForwardRef as ReactComponent };